module.exports = __webpack_public_path__ + "static/media/book.50d85f08.svg";